<div class="default-img-wrapper" [class.bright]="bright">
  <img src="assets/images/visual/user-avatar.svg" alt="">
</div>
